import React, { useRef, useState, useCallback } from "react";
import { Modal, Form, Row, Col, Input } from "antd";
import { connect } from "dva";

const { TextArea } = Input;

const ToggleHoldModal = ({ adminShipmentView, dispatch, visible, onClose }) => {
  const formRef = useRef();

  const [loading, setLoading] = useState(false);

  const closeAndReset = useCallback(() => {
    setLoading(false);
    formRef.current.resetFields();

    if (typeof onClose === "function") {
      onClose();
    }
  }, [onClose]);

  const handleOnHoldToggle = useCallback(() => {
    const adminShipmentData = adminShipmentView.data;

    formRef.current.validateFields().then(data => {
      setLoading(true);

      dispatch({
        type: "adminShipmentView/placeShipmentOnHold",
        shipmentId: adminShipmentData.id,
        reason: data.note,
      }).then(() => {
        closeAndReset();
      });
    });
  }, [adminShipmentView, dispatch]);

  return (
    <Modal
      title={adminShipmentView?.data?.onHold ? "Remove Hold" : "Place on Hold"}
      visible={visible}
      onOk={handleOnHoldToggle}
      onCancel={closeAndReset}
      confirmLoading={loading}
    >
      <Form ref={formRef} initialValues={{ onHold: adminShipmentView?.data?.onHold }}>
        <Row gutter={16}>
          <Col flex={1}>
            <Form.Item
              name="note"
              rules={[
                {
                  required: !adminShipmentView?.data?.onHold,
                  message: "Please enter reason",
                },
              ]}
            >
              <TextArea
                rows={4}
                placeholder={
                  adminShipmentView?.data?.onHold
                    ? "Reason for taking shipment off hold (Optional)"
                    : "Reason for holding shipment"
                }
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(ToggleHoldModal);
